import { render, staticRenderFns } from "./TittleSurvey.vue?vue&type=template&id=533120d8&scoped=true&"
import script from "./TittleSurvey.vue?vue&type=script&lang=js&"
export * from "./TittleSurvey.vue?vue&type=script&lang=js&"
import style0 from "./TittleSurvey.vue?vue&type=style&index=0&id=533120d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533120d8",
  null
  
)

export default component.exports